import { Component, OnInit, ViewChild, Input, ElementRef, Output } from '@angular/core';

@Component({
	selector: 'app-view-stack-view',
	templateUrl: './view-stack-view.component.html',
	styleUrls: ['./view-stack-view.component.scss']
})
export class ViewStackViewComponent implements OnInit {

	private varName = '';
	public get viewVariable(): string {
		return this.varName;
	}
	get element(): ElementRef {
		return this.domNode;
	}
	// tslint:disable-next-line: no-input-rename
	@Input() viewName: string;
	@Input() showInNav = true;
	@Output() dataset: any;
	constructor(private domNode: ElementRef) { }

	ngOnInit() {
		this.dataset = this.domNode.nativeElement.dataset;
		this.varName = this.domNode.nativeElement.getAttribute('data-var');
		if (this.varName === null) {
			this.varName = '';
		}
	}

	ToggleActive(onOff: boolean) {
		$(this.domNode.nativeElement).toggleClass('active', onOff);

	}
	IsActive() {
		return this.domNode.nativeElement.classList.contains('active');
	}

}
